export const selectIsAllFeaturesEnabled = (state) => state?.isAllFeaturesEnabled ?? false;
